'use client';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "../src/index.css";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import "flowbite/dist/flowbite.css";
import { ChatProvider } from "./hooks/useChat.jsx";
import { Amplify } from "aws-amplify";
import { Provider } from "react-redux";
import { store } from "./reduxStore/store.js";
/* import awsExports from './aws-exports.jsx/index.js'; */
/* import awsExports from "./aws-exports.jsx"; */
// import awsExports from "./aws-exports.js";

axios.defaults.withCredentials = true;
// Amplify.configure(awsExports);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || "",
      userPoolClientId: import.meta.env.VITE_CLIENT_ID || "",
      signUpVerificationMethod: "code",
      loginWith: {
        oauth: {
          domain: "docaide.ai",
          scopes: [
            "phone",
            "email",
            "profile",
            "openid",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: ["http://localhost:3000/"],
          redirectSignOut: ["http://localhost:3000/"],
          responseType: "code",
        },
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ChatProvider>
          <App />
        </ChatProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
